"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParentNotConnectToChildError = void 0;
const client_library_1 = require("@seneca/client-library");
class ParentNotConnectToChildError extends client_library_1.ExtendableError {
    constructor(childId) {
        super(`Parent is not connected to child with id ${childId}`);
    }
}
exports.ParentNotConnectToChildError = ParentNotConnectToChildError;
//# sourceMappingURL=ParentNotConnectedToChild.js.map